import $               from 'jquery';
import template        from './template.hbs';
import FormStep        from '../../classes/form-step';
import StripeElems     from '../../util/stripeUtil';
import billingTmpl     from '../../templates/components/billing_address.hbs';
import mask            from '../../util/phone-mask';
import { formatTrial, getBillingStart } from '../../util/trialPeriod';
import sidebarTemplate from '../../templates/components/order-summary.hbs';
import extend          from '../../util/extend';
import * as trialcodes from '../../util/trialcodes';

const stripeOpts = {
  fonts: [
    {
      family: 'brown',
      // eslint-disable-next-line max-len
      src: 'url(\'https://dyajmw2sca9cs.cloudfront.net/fonts/lineto-brown-pro-light.eot?\') format(\'embedded-opentype\'), url(\'https://dyajmw2sca9cs.cloudfront.net/fonts/BrownProTT-Light.ttf\') format(\'truetype\')'
    }
  ]
};

function getElementConfig( amount ) {
  return {
    paymentRequestButton: '#payment-request-button',
    paymentRequest: {
      country: 'US',
      currency: 'usd',
      total: {
        label: `Starry Internet`,
        amount: amount | 0
      },
      requestPayerName: true
    },
    paymentRequestStyle: {
      paymentRequestButton: {
        type: 'default',
        theme: 'light-outline'
      }
    }
  };
}

const defaultElementOpts = {
  classes: {
    base: 'cc-form'
  },
  style: {
    base: {
      fontWeight: 200,
      color: '#46425e',
      fontFamily: 'brown',
      fontSize: '14.5px',
      '::placeholder': {
        color: '#bfbfbf'
      }
    },
    invalid: {
      color: 'inherit'
    }
  }
};

const ccFieldConfigs = {
  cardNumber: {
    component: '#cc_number_element'
  },
  cardExpiry: {
    component: '#cc_expiry_element'
  },
  cardCvc: {
    component: '#cc_cvc_element'
  }
};

const ccStep = new FormStep({

  $el: $(`
    <form
      class="form-step form-step--large step-payment"
      action="canvas"
    />
  `),

  template,

  events: {
    afterRender: 'postRender'
  },

  ccModule: {},

  // create a token and send it to our store
  beforeNext( state, cb ) {
    const billingAddressType = state.billing_same_as_service === true
      ? 'address'
      : 'billing';

    const addr = state[ billingAddressType ];
    const first_name = addr.first_name || state.first_name;
    const last_name = addr.last_name || state.last_name;

    const opts = {
      address_zip: addr.zip,
      name: `${ first_name } ${ last_name }`,
      address_line1: addr.line1,
      address_city: addr.city,
      address_state: addr.state
    };

    if ( addr.line2 ) {
      opts.address_line2 = addr.line2;
    }

    if ( addr.country ) {
      opts.address_country = addr.country;
    }

    let promise;

    if ( this.paymentRequestResponse ) {
      promise = Promise.resolve( this.paymentRequestResponse );
    } else {
      promise = this.ccModule.createToken( opts );
    }

    promise.then( ({ token, error }) => {

      if ( window.acumen && error ) {
        window.acumen.track( 'web-submit-payment', {
          success: false,
          error: error.message || null
        });
      }

      if ( error ) {
        const defaultMsg = 'Something went wrong, please try again';
        this.showCardError( error.message || defaultMsg );
        return cb( error );
      }

      const { id, card } = token;

      this.dispatch({ type: 'change', data: {
        'source': id,
        'billing.cc_last_4': card.last4,
        'billing.cc_expiry': `${ card.exp_month }.${ card.exp_year }`,
        'billing.cc_brand': card.brand
      } });

      cb();
    });
  },

  trackPromo( code, success, reason = null ) {
    if ( window.acumen ) {
      window.acumen.track(
        'web-click-apply_promo',
        { code: code.toLowerCase(), success, reason }
      );
    }
  },

  showCardError( message ) {
    const errorField = this.$el.find('.js-paymentError');
    errorField.text( message ).show();

    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;

    if ( this.paymentRequestResponse ) {
      this.paymentRequestResponse = null;
      this.ccModule.gotPaymentRequestToken = false;
      this.$el.find('.hide-on-payment-api-success').show();
      this.$el.find('.show-on-payment-api-success').hide();
    }
  },

  postRender() {

    this.$el.on( 'change', '[name="billing_same_as_service"]', ( evt ) => {
      const val = evt.target.checked;
      const prop = evt.target.name;
      this.toggleBilling( this.setState({ [ prop ]: val }) );
    });

    this.$el.on( 'change', '.js-billingAddress input', ( evt ) => {
      const val = evt.target.value;
      const prop = evt.target.name;
      this.setState({ [ prop ]: val });
    });

    // Run only on initial on initial render
    if ( !this.loaded ) {
      this.loaded = true;

      // If there is a promo code in the initial state, auto-apply it
      if ( this.getState().trial_code ) {
        this.$el.find('.js-applyPromo').click();
      }
    }

    this.renderCCfields();
  },

  toggleBilling( state = this.localState ) {
    const html = billingTmpl( state, {}, true );
    this.$el.find('.js-billingAddress').html( html );

    if ( !state.billing_same_as_service ) {
      const input = this.$el.find('#billing-address-phone')[ 0 ];
      mask( input );
    }
  },

  updateErrorClass( el ) {
    $( el.component )[ el.valid ? 'removeClass' : 'addClass' ]('error');
  },

  updateErrorText( el ) {
    $( el.component ).next('.error-message').text( el.getErrorMessage() );
  },

  removeError( el ) {
    if ( el.valid ) {
      $( el.component ).removeClass('error');
      this.updateErrorText( el );
      this.$el.find('.js-paymentError').hide();
    }
  },

  updateNextButton() {
    this.dispatch({ type: 'change', data: {} });
  },

  handleCreditCardChange( context ) {
    this.updateNextButton();
    this.removeError( context.element );
  },

  handleCreditCardBlur( context ) {
    this.updateErrorClass( context.element );
    this.updateErrorText( context.element );
    this.removeError( context.element );
  },
  defaultState: {
    btnText: 'Apply',
    disabled: false,
    errorMessage: '',
    hasError: false,
    trial_period_days: 0,
    btnClass: 'btn--primary-red',
    promoApplied: false,
    promoMessage: null,
    trial_code:
      new URLSearchParams( window.location.search ).get('trial_code') || ''
  },
  getState( props = {} ) {
    return Object.assign( {}, this.defaultState, this.localState, props );
  },
  // synchronously handle promo submit event
  applyPromo( e ) {
    e.preventDefault();

    const state          = this.localState;
    const name           = this.$el.find('[name="promo_code"]')[ 0 ].value;
    const place_id       = state.address.place_id;
    const plan_id        = this.getState().plan;
    const plan           = window.plans.find( p => p.id === plan_id );
    const previous_trial = state.trial_period_days || state.original_trial;

    if ( name === '' ) {
      this.setState({
        trial_code: '',
        errorMessage: 'Please enter a valid promo code',
        hasError: true,
        trial_period_days: previous_trial
      });
      this.trackPromo( '', false, 'missing_code' );
      return this.renderPromo();
    }

    this.checkPromo({ name, plan, place_id, previous_trial });
  },
  // asynchronously check promo code and render success/error messages
  // as appropriate
  async checkPromo({ name, plan, place_id, previous_trial }) {
    this.setState({
      disabled: true,
      trial_code: name,
      btnClass: 'loading btn--primary-red',
      btnText: ''
    });

    this.renderPromo();

    const {
      error,
      error_code,
      message,
      trialcode
    } = await trialcodes.check({ name, plan, place_id, previous_trial });

    if ( error ) {
      this.setState({
        disabled: false,
        errorMessage: error,
        trial_code: name,
        btnClass: 'btn--primary-red',
        btnText: 'Apply'
      });
      this.trackPromo( name, false, error_code );
      return this.renderPromo();
    }

    const days = trialcodes.get_trial_days({ trialcode, plan });

    this.setState({
      disabled: false,
      trial_period_days: days,
      trial_code: name,
      btnClass: 'btn--primary-blue success',
      hasError: false,
      errorMessage: '',
      btnText: '',
      promoApplied: true,
      promoMessage: message || null
    });

    this.trackPromo( name, true );

    this.dispatch({
      type: 'change',
      data: { trial_period_days: days, trial_code: name }
    });

    const duration  = this.$el.find('.js-trialDuration');
    const opts      = { promoResultClass: 'fadein' };

    duration.fadeOut( this.renderPromo.bind( this, opts ) );

    this.renderPromo();
  },
  bindEvents() {
    this.$el.on( 'click', '.js-applyPromo', this.applyPromo.bind( this ) );
    return FormStep.prototype.bindEvents.call( this );
  },
  renderPromo( props ) {
    const state         = this.getState();
    const promoTokens   = this.getPromoTokens( props );
    const summaryTokens = this.getSummaryTokens();
    const tokens        = extend( {}, state, summaryTokens, promoTokens );
    const resHTML       = sidebarTemplate( tokens );

    this.$el.find('.js-paymentSidebar').html( resHTML );
  },
  getSummaryTokens( props ) {
    const state        = this.getState( props );
    const plan_amount  = state.plan_amount / 100;

    const billingStart = getBillingStart(
      state.install_date,
      state.trial_period_days + state.referral_code_days
    ).format('MMM Do, YYYY');

    return extend(
      {},
      {
        formattedTrial: formatTrial( state.trial_period_days ),
        install_date: state.install_date,
        billingStart,
        dueAtInstall: ( state.trial_period_days > 0 ) ? 0 : plan_amount,
        plan_name: state.plan_name,
        plan_amount,
        referral_code_used: Boolean( state.referral_code_used ),
        formatted_referral: formatTrial( state.referral_code_days )
      }
    );
  },
  getPromoTokens( props ) {
    const state             = this.getState( props );
    const trial_period_days = state.trial_period_days | 0;
    const trial_code        = state.trial_code || '';
    const has_promo         = !!state.promoApplied;
    const has_trial         = trial_period_days > 0;

    return {
      has_trial,
      btnText: state.btnText,
      btnClass: state.btnClass,
      trial_code,
      promo_period_days: has_promo ? trial_period_days : null,
      promo_message: state.promoMessage
    };
  },
  render( state ) {
    this.localState = extend(
      { original_trial: state.trial_period_days },
      state
    );

    const sidebarTokens  = extend(
      {},
      this.getPromoTokens( state ),
      this.getSummaryTokens( state )
    );

    const sidebarMarkup  = sidebarTemplate( sidebarTokens, {}, true );
    const tokens         = Object.assign( {}, state, { sidebarMarkup }, {
      plan_amount: ( this.localState.plan_amount / 100 )
    });

    FormStep.prototype.render.call( this, tokens );
    this.toggleBilling( tokens );
  },

  renderCCfields() {
    const amount  = this.localState.plan_amount;

    this.ccModule = new StripeElems( stripeOpts, getElementConfig( amount ) );
    this.ccModule.createElements( ccFieldConfigs, {
      defaultElementOpts,
      events: {
        'change': this.handleCreditCardChange.bind( this ),
        'blur': this.handleCreditCardBlur.bind( this )
      }
    });

    this.paymentRequestResponse = null;

    this.ccModule.onPaymentRequestResponse = ev => {
      this.paymentRequestResponse = ev;

      if ( ev.token ) {
        this.$el.find('.hide-on-payment-api-success').hide();
        this.$el.find('.show-on-payment-api-success').show();
      }
    };

    this.ccModule.onCanMakePayment = () => {
      this.$el.find('#payment-request-text').show();
      this.$el.find('.js-orderSummary').addClass('app-pay-enabled');
    };

    this.ccModule.renderFields();

    // focus on the credit card number field after it loads

    if ( !( 'ontouchstart' in window ) ) {
      this.$el.find('#cc_number_element iframe').on( 'load', () => {
        // respect autofocus on desktop
        this.ccModule.getStripeElement('cardNumber').focus();
      });
    }
  },

  rules: {
    'billing.first_name': /\S+/,
    'billing.last_name': /\S+/,
    'billing.line1': /\S+/,
    'billing.city': /\S+/,
    'billing.state': /^[A-Z]{2}$/,
    'billing.zip': /^\d{5}(?:[-\s]\d{4})?$/,
    // eslint-disable-next-line max-len
    'billing.phone': /^([0-1]([\s-./\\])?)?(\(?[2-9]\d{2}\)?|[2-9]\d{3})([\s-./\\])?(\d{3}([\s-./\\])?\d{4}|[a-zA-Z0-9]{7})$/,
    'agree_to_terms': x => x === true
  },

  isValid( state, showErrors ) {
    const ccValid = this.ccModule.valid();
    const formValid = FormStep.prototype.isValid.call(
      this,
      state,
      showErrors
    );

    return ccValid && formValid;
  }

});

export default ccStep;
